import { NodeNames } from '@farmersdog/constants';

import { validationSchema } from './yupValidation';

export function isValidEmail(email: string) {
  const rule = validationSchema[NodeNames.Email];
  return rule.isValidSync(email);
}
